// extracted by mini-css-extract-plugin
export default {"tag":"PaymentRequestStatusTag-module__tag--DIcCI","large":"PaymentRequestStatusTag-module__large--ZXiDv","status":"PaymentRequestStatusTag-module__status--Hht5r"};